import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import DiscussionPage from 'flarum/forum/components/DiscussionPage';
import IndexPage from 'flarum/forum/components/IndexPage';
import LinkButton from 'flarum/common/components/LinkButton';
import Separator from 'flarum/common/components/Separator';
import ItemList from 'flarum/common/utils/ItemList';
import listItems from 'flarum/common/helpers/listItems';
export default function extendMobileNavigation(app) {
  const injectNavigation = function (vnode) {
    if (vnode && vnode.children) {
      if (!Array.isArray(vnode.children)) {
        vnode.children = [vnode.children];
      }
      const children = vnode.children;

      // 1. Build Mobile Category Selector only for DiscussionPage on mobile
      let selector = null;
      if (this instanceof DiscussionPage) {
        const discussion = this.discussion;
        if (discussion) {
          let labelText = 'Todas las discusiones';
          const tags = discussion.tags();
          if (tags && tags.length > 0) {
            const firstTag = tags[0];
            labelText = typeof firstTag.name === 'function' ? firstTag.name() : firstTag.name || 'Categoría';
          }
          selector = m('div', {
            className: 'mobile-nav-menu-bar'
          }, [m('div', {
            className: 'Dropdown'
          }, [m('button', {
            className: 'Button Button--category-selector Button--full-width Dropdown-toggle',
            'data-toggle': 'dropdown'
          }, [m('span.Button-label', labelText), m('i.fas.fa-chevron-down.Dropdown-caret', {
            style: 'margin-left: auto; font-size: 10px; opacity: 0.5;'
          })]), m('ul', {
            className: 'Dropdown-menu'
          }, listItems(this.navItems().toArray()))])]);
        }
      }

      // 2. Inject into the VDOM
      // We prepend the selector if on mobile to replace breadcrumbs
      if (selector) children.unshift(selector);
    }
  };
  extend(DiscussionPage.prototype, 'view', injectNavigation);
  extend(IndexPage.prototype, 'view', injectNavigation);

  // Provide navItems for DiscussionPage
  DiscussionPage.prototype.navItems = function () {
    var _app$search;
    const items = new ItemList();
    const params = app.search && typeof app.search.stickyParams === 'function' ? app.search.stickyParams() : (_app$search = app.search) != null && (_app$search = _app$search.state) != null && _app$search.params ? app.search.state.params() : {};
    items.add('allDiscussions', m(LinkButton, {
      href: app.route('index', params),
      icon: 'far fa-comments'
    }, app.translator.trans('core.forum.index.all_discussions_link')), 100);
    const tags = app.store.all('tags');
    if (tags && tags.length > 0) {
      items.add('separator', m(Separator), -12);
      const sortedTags = tags.filter(tag => tag.position() !== null && !tag.isChild()).sort((a, b) => (a.position() || 0) - (b.position() || 0));
      sortedTags.forEach(tag => {
        items.add('tag' + tag.id(), m(LinkButton, {
          icon: 'fas fa-tag',
          href: app.route('tag', {
            tags: tag.slug()
          })
        }, tag.name()), -14);
      });
    }
    return items;
  };
}